import { ICreateItensServicoEmpreendimentoUseCase } from "../../../presentation/useCases/create/create_itens_servico_empreendimento_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * CreateItensServicoEmpreendimentoUseCase
 */

export class CreateItensServicoEmpreendimentoUseCase implements ICreateItensServicoEmpreendimentoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async createItensServicoEmpreendimento(
    idEmpreendimento: number,
    idsBloco: number[],
    idsUnidade: number[],
    idsChecklistServico: number[],
    quantidade?: number,
    valorUnitario?: number,
    salvarPorBloco?: number,
  ): Promise<number[]> {
    const listaIds = await this.repository.createItensServicoEmpreendimento(
      idEmpreendimento,
      idsBloco,
      idsUnidade,
      idsChecklistServico,
      quantidade,
      valorUnitario,
      salvarPorBloco
    );
    return listaIds;

  }
}
